import request from "@src/utils/request";

interface OrderFilters {
  pageSize?: number;
  page?: number;
  orderStatus?: string | null;
  distributor?: string | null;
  search?: string | null;
  orderDate?: Record<string, boolean>;
  [key: string]: any;
}

export function placeOrder() {
  return request().post("/api/v1/orders/").send();
}

export function placeOrderForDistributor(distributorSlug: string) {
  return request()
    .post("/api/v1/orders/checkout-for-distributor/")
    .send({ distributorSlug });
}

export function getOrder(orderNumber: string) {
  return request().get(`/api/v1/orders/${orderNumber}/`).send();
}

export function getOrders(filters: OrderFilters = {}) {
  return request().query(filters).get("/api/v1/orders/").send();
}

export function getLatestOrder() {
  return request().get("/api/v1/orders/latest/").send();
}
